import React, { forwardRef } from 'react';
const VolumeOff = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 24 24", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("g", { fill: "currentColor" },
        React.createElement("path", { d: "M1.048-.012-.012 1.05l22.936 22.937 1.061-1.061zM10.5 3.75l-1.8 1.8 1.8 1.763zM9 16.65l-2.4-2.362H1.5V9.75h5.062l-1.5-1.5H0v7.538h6l4.5 4.462v-6.562l-1.5-1.5zM20.662 17.513 21.75 18.6c1.387-1.95 2.25-4.35 2.25-6.937 0-3-1.125-5.775-2.963-7.875l-1.05 1.05c1.538 1.8 2.513 4.2 2.513 6.787 0 2.175-.675 4.2-1.838 5.888zM17.962 14.775l1.088 1.088a8.096 8.096 0 0 0 1.2-4.238c0-1.987-.713-3.787-1.875-5.212l-1.05 1.05a6.733 6.733 0 0 1 1.425 4.162c0 1.125-.3 2.213-.788 3.15zM15 11.813l1.275 1.275c.15-.45.262-.938.262-1.463 0-.937-.3-1.8-.787-2.55l-1.125 1.088c.225.412.375.937.375 1.462z" })))));
VolumeOff.displayName = 'VolumeOff';
// @ts-ignore;
const iconData = {
    glyph: VolumeOff,
    group: 'media',
};
export default iconData;
